var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map"}},[_c('GmapMap',{ref:"mapRef",attrs:{"center":{ lat: 37.86926, lng: -122.254811 },"zoom":1,"id":"mapClassic","map-type-id":"roadmap","options":{
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }